/* OREN — hero lit reveal */
/* Lit reveal */
(function(){
  if(!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('lit'); io.unobserve(en.target); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.hero-statement, .hero-meta, .hero-immersive-caption').forEach(function(el){
    io.observe(el);
  });
})();
